/* eslint import/prefer-default-export: 0 */

// dependencies
import { CreateProcess } from "redux-process";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const GetLambdaFunctions = CreateProcess({
	method: "GET",
	name: "Get Lambda Functions",
	type: "LAMBDA:GETFUNCTIONS",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/lambda-functions/`,
		};
	},

	success: (response) => {
		const functions = response.data.results;
		const count = response.data.count;

		return {
			functions,
			count,
		};
	},
});
